/* @flow */
const IMPORT_LOGS_ERROR_LIST = 'IMPORT_LOGS_ERROR_LIST';

export default IMPORT_LOGS_ERROR_LIST;

